import {Observable} from 'rxjs';

export abstract class RolesService {
    abstract getList(): Observable<string[]>;
}
